/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, showModal } from '../../twd'

export default ({tab, rows}) => {

    let isRatio = tab!=='MOST_ACTIVE_BUYS'
    let totals = { buys: 0, sells: 0}

    return <div className="table-responsive">
    <table
        data-name="corporate-market-snapshot-table"
        className="table table-hover align-top">
        <thead>
        <tr>
        <th>Symbol</th>
        <th>Issuer</th>
        {!isRatio && <React.Fragment>
            <th className="text-right">CUSIPs</th>
            <th className="text-right">Trades</th>
            <th className="text-right" nowrap="true">Par Value<br/>Traded (MM)</th>
        </React.Fragment>}
        {isRatio && <React.Fragment>
            <th className="text-right">Buys</th>
            <th className="text-right">Sells</th>
            <th className="text-right">Ratio</th>
        </React.Fragment>}

        <th className="text-right" nowrap="true">Median Yield</th>
        </tr>
    </thead>
    <tbody>{
        rows && rows.map( (r,i) => {
            if (isRatio) {
                totals.buys += r.buys
                totals.sells += r.sells
            }
            return <tr
            data-name="corporate-market-snapshot-row"
            key={i}>
                <td>{formatSymbol(r)}</td>
                <td>{r.issuer || r.ticker}</td>
                {!isRatio && <React.Fragment>
                    <td className="text-right">{fmt.count(r.cusips)}</td>
                    <td className="text-right">{fmt.count(r.trades)}</td>
                    <td className="text-right">${(r.parValue)}</td>
                </React.Fragment>}
                {isRatio && <React.Fragment>
                    <td className="text-right">{fmt.count(r.buys)}</td>
                    <td className="text-right">{fmt.count(r.sells)}</td>
                    <td className="text-right">{formatRatio(r)}</td>
                </React.Fragment>}
                <td className="text-right">{fmt.ytw(r.medianYield)}%</td>
            </tr>
        })
    }</tbody>
    {isRatio && <tfoot>
        <tr className="text-right">
            <td className="text-left" colSpan="2">TOTALS</td>
            <td>{fmt.count(totals.buys)}</td>
            <td>{fmt.count(totals.sells)}</td>
            <td>{formatRatio(totals)}</td>
            <td></td>
        </tr>
    </tfoot>}
    </table>
    </div>
}

const formatSymbol = ({ticker:symbol, issuer}) => (
    <button
        data-name="corporate-market-snapshot-symbol-link"
        data-symbol={symbol}
        className="link-button"
        onClick={(e) => {
            let p = {
                view:'offerings-modal',
                name: issuer,
                params: {
                    persistToPreviousSearches: false,
                    holdInvType: ['C'],
                    holdSymbol: [symbol]
                },
                maturity: 'ALL',
                from: 'corporates',
                source: e.target,
            }
            showModal(p)
        }}
    >{symbol}</button>
)

const formatRatio = ({buys, sells}) => {
    if (!sells) return '-'
    let a = buys/sells
    return a.toFixed(3)
}